import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { message } from 'antd'
import type { SuburbConfig } from 'config/constants/types'
import { StringChain } from 'lodash'
import type { TeamListState, TeamList } from '../types'
import { getTeamListings, removeTeamListing, sendToQa, addTeamListing } from './helpers'

// qaListReducer

const noTeamListConfig = {
  listings: [],
  isInitialized: false,
  isLoading: true,
  hasError: false,
}

interface SetListingsEditPayload {
  listings: TeamList[]
}

const initialState: TeamListState = { ...noTeamListConfig }

export const teamListSlice = createSlice({
  name: 'TeamList',
  initialState,
  reducers: {
    fetchTeamListings: (state) => {
      state.isLoading = true
      state.hasError = false
    },
    setTeamListings: (state, action: PayloadAction<SetListingsEditPayload>) => {
      state.listings = action.payload.listings
      state.isLoading = false
      state.isInitialized = true
      state.hasError = false
    },
    fetchTeamListingsFailed: (state) => {
      state.listings = []
      state.isInitialized = false
      state.isLoading = false
      state.hasError = true
    },
  },
})

export const fetchTeamList = (userId: string) => async (dispatch) => {
  console.log(userId)
  try {
    dispatch(fetchTeamListings())
    const listings = await getTeamListings(userId)
    dispatch(
      setTeamListings({
        listings,
      }),
    )
  } catch (error) {
    message.error('Error gettings QA list')
    dispatch(fetchTeamListingsFailed())
  }
}

export const removeFromTeamList = (qaId: string, propertyId: string) => async (dispatch) => {
  try {
    dispatch(fetchTeamListings())
    const tokenData = localStorage.getItem('bba-token') ? JSON.parse(localStorage.getItem('bba-token')) : null
    const removeListing = await removeTeamListing(qaId, propertyId)
    if (removeListing) {
      message.success('Listing Removed')
    }
    const listings = await getTeamListings(tokenData._id)
    dispatch(
      setTeamListings({
        listings,
      }),
    )
  } catch (error) {
    message.error('Error gettings QA list')
    dispatch(fetchTeamListingsFailed())
  }
}

export const addToTeamList =
  (userId: string, propertyIds, qaId: string, shortName: string, qaName: string) => async (dispatch) => {
    try {
      dispatch(fetchTeamListings())
      const tokenData = localStorage.getItem('bba-token') ? JSON.parse(localStorage.getItem('bba-token')) : null
      const addListing = await addTeamListing(userId, propertyIds, qaId, shortName, qaName)
      if (addListing) {
        message.success('Listings Added')
      }
      //   const listings = await getTeamListings(tokenData._id)
      //   dispatch(
      // 	setTeamListings({
      // 	  listings,
      // 	}),
      //   )
    } catch (error) {
      message.error('Error sending to list')
      // dispatch(fetchTeamListingsFailed())
    }
  }

export const sendTeamListingQA = (propertyId: string, qaId: string, propertyData: string) => async (dispatch) => {
  //   console.log('propertyData')
  //   console.log(propertyData)
  try {
    dispatch(fetchTeamListings())
    const tokenData = localStorage.getItem('bba-token') ? JSON.parse(localStorage.getItem('bba-token')) : null
    const sendToQaResponse = await sendToQa(propertyId, qaId, propertyData)

    // console.log('sendToQaResponse')
    // console.log(sendToQaResponse)

    if (sendToQaResponse) {
      message.success('Property is in QA que')
    } else {
      message.error('Property is already in QA que')
    }
    const listings = await getTeamListings(tokenData._id)
    dispatch(
      setTeamListings({
        listings,
      }),
    )

    //   const listingQData = await getCouncilListingEdit(_id)
    //   dispatch(setListing(listingData))
  } catch (error) {
    message.error('Property is already in QA que')
    dispatch(fetchTeamListingsFailed())
  }
}

// Actions
export const { fetchTeamListings, setTeamListings, fetchTeamListingsFailed } = teamListSlice.actions

export default teamListSlice.reducer
